import type { Department } from "@/components/acl/group-uesr-list/Departments/values/Department";
import { useDomainStore } from "@/store/domain-store";
import { ServerApiAccess } from "../server-api-access";

export default class GetDepartmentsTask {
  public static async run(domainId: string): Promise<void> {
    const access = new ServerApiAccess();

    const task = async () => {
      try {
        const departments = await access.listDepartments(domainId);
        // listDepartments は @/API の Department[] を返すが、store は UI 層の
        // Department[] を期待する。旧 Vuex(dispatch) 時代から続く既存挙動を踏襲し、
        // 型のみキャストで合わせる（ランタイム挙動は不変）。
        await useDomainStore().setDepartments(
          departments as unknown as Department[],
        );
      } catch (error) {
        console.error("get-departments error:%O", error);
      }
    };

    await task();
  }
}
